export default "__VITE_ASSET__27f547f1__"